import React, {useEffect, useState, useRef} from "react";
import qs from "qs";
import StrategyConfigurator from "./components/StrategyConfigurator";
import axios from "axios";
import { API } from "../../utilities/api.config";
import Loading from "../../components/Loading/Loading";
import CyPortfolioDetailsSortable from "../../components/Charts/CyPortfolioDetailsSortable";
import { generateChartData } from "../../utilities/cpr";
import moment from "moment";
import CyLineChart from "../../components/Charts/CyLineChart";
import CyPortfolioRiskMetrics from "../../components/Charts/CyPortfolioRiskMetrics";
import CyPortfolioReturn from "../../components/Charts/CyPortfolioReturn";
import CyPortfolioCalendarYearReturnTable from "../../components/Charts/CyPortfolioCalendarYearReturnTable";
import CyPortfolioModelConstituentDisclosure from "../../components/Charts/CyPortfolioModelConstituentDisclosure";
import { CyManagerTypes } from "../../utilities/managerTypes";
import {REQUIRED_LEVEL} from "../../utilities/access";

const CprTest = (props) => {
  const STRATEGY_FIXTURE = {
    solveFor: 'risk',
    managerType: 'All',
    includeTheoretical: false,
    rror: 0.06,
    riskTolerance: -0.05,
    riskPeriod: 'worst.calendar.year',
    singleStrategy: ''
  }
  const parsedQueryString = qs.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  const isFirstRender = useRef(true);
  const { app, token } = parsedQueryString;
  const [strategyParam, setStrategyParam] = useState(STRATEGY_FIXTURE);
  const [singleStrategies, setSingleStrategies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fakePortfolio, setFakePortfolio] = useState({
    metadata: {
      initialInvestment: 1000000,
      advisorConfig: {
        inflationRate: 0.02
      }
    },
    cprRecommendation: null
  })

  const managerTypeList = CyManagerTypes.getManagerTypes(app, true, REQUIRED_LEVEL.PREMIUM);

  useEffect(() => {
    fetchSingleStrategies()
  }, []);

  useEffect(() => {
    if ( isFirstRender.current ) {
      isFirstRender.current = false;
      return;
    }
    fetchCprData();
  }, [strategyParam]);
  const handleChange = (name, booleanValue, event) => {
    if (booleanValue) {
      setStrategyParam({
        ...strategyParam,
        [name]: event.target.checked
      })
    } else {
      if (name === "managerType") {
        let includeTheoretical = false;
        let riskPeriod = strategyParam.riskPeriod;
        let riskTolerance = strategyParam.riskTolerance;
        let rror = strategyParam.rror;
        let singleStrategy = strategyParam.singleStrategy;
        const managerType = event.target.value;
        // Force turn off includeTheoretical when manager type doesn't allow
        if (managerTypeList.filter(m => m.allowBackTested === false).find(m => m.code === managerType)) {
          includeTheoretical = false;
        }
        switch (managerType) {
          case "401k":
            includeTheoretical = false;
            riskPeriod = "mdd";
            if (["-0.25", "-0.35"].some((v) => v === riskTolerance))
              riskTolerance = "-0.05";
            if (["0.06", "0.08", "0.1", "0.12"].some((v) => v !== rror))
              rror = "0.06";
            break;
          case "WBI Portfolios":
          case "WBI Envestnet":
          case "Other Models":
            singleStrategy = singleStrategies[event.target.value][0].strategyScenario
            break;
          default:
            break;
        }
        setStrategyParam({
          ...strategyParam,
          [name]: event.target.value,
          includeTheoretical: includeTheoretical,
          riskPeriod,
          riskTolerance,
          rror,
          singleStrategy
        })
      } else {
        setStrategyParam({
          ...strategyParam,
          [name]: event.target.value
        })
      }
    }
  };

  const fetchSingleStrategies = () => {
    setLoading(true);
    axios.get(
      API.SINGLE_STRATEGIES,
      {
        headers: token ? {"X-WBI-Auth": token} : {},
        params: { app }
      })
      .then(({ data }) => {
        setSingleStrategies(data);
        setStrategyParam({...strategyParam, singleStrategy: data[0] ? data[0].strategyScenario : ''});
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log('Some error occurred');
      })
  }
  const fetchCprData = () => {
    setLoading(true);
    axios
      .get(API.CPR_DATA,
        {
          headers: token ? {"X-WBI-Auth": token} : {},
          params: { app, ...strategyParam }
        })
      .then(({ data }) => {
        setLoading(false);
        setFakePortfolio({...fakePortfolio, cprRecommendation: data});
      })
      .catch((error) => {
        setLoading(false);
        console.log('Some error occurred');
      })
  }
  if (!app && !token) {
    return <React.Fragment>
      Missing query param: app
    </React.Fragment>
  }
  const { cprRecommendation } = fakePortfolio;
  const baseChartData = generateChartData(fakePortfolio);
  const useWbiSingleStrategy = ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(strategyParam.managerType);
  const strategyStartDate = baseChartData && moment(baseChartData[0].date)
    .startOf("month")
    .subtract(2, "months");

  return <React.Fragment>
    <StrategyConfigurator
      appName={app}
      strategyParam={strategyParam}
      handleStrategyParamChange={handleChange}
      wbiStrategyList={singleStrategies[strategyParam.managerType] || []}
      managerTypeList={managerTypeList}
    />
    <section style={{padding: '110px 20px'}}>
    {
      loading || !cprRecommendation ?
        <Loading /> :
        <React.Fragment>
          <CyPortfolioDetailsSortable
            strategyStartDate={strategyStartDate}
            managerList={
              cprRecommendation.managers
            }
            portfolioSummary={
              cprRecommendation.summary
            }
            finalWealth={baseChartData.slice(-1)[0]}
            riskPeriod={strategyParam.riskPeriod}
          />
          <CyLineChart
            data={baseChartData}
            initialInvestment={
              fakePortfolio.metadata.initialInvestment
            }
            showTooltip={false}
            portfolioName={''}
            benchmarkName={cprRecommendation.summary.benchmark.Name}
          />
          <CyPortfolioRiskMetrics
            startDate={strategyStartDate.format("MM/DD/YYYY")}
            managerList={cprRecommendation.managers}
            portfolioDisplayName={cprRecommendation.displayName || ""}
            portfolioSummary={cprRecommendation.summary}
            useWbiSingleStrategy={useWbiSingleStrategy}
          />
          <CyPortfolioReturn
            startDate={strategyStartDate.format("MM/DD/YYYY")}
            managerList={cprRecommendation.managers}
            portfolioDisplayName={cprRecommendation.displayName || ""}
            portfolioSummary={cprRecommendation.summary}
            useWbiSingleStrategy={useWbiSingleStrategy}
          />
          {cprRecommendation.calendarYearReturn &&
            cprRecommendation.calendarYearReturn.startYear &&
            cprRecommendation.calendarYearReturn.CprCalYearReturn &&
            cprRecommendation.calendarYearReturn.BenchmarkCalYearReturn && (
            <CyPortfolioCalendarYearReturnTable
              portfolioDisplayName={cprRecommendation.displayName || ""}
              calendarYearReturnData={
                cprRecommendation.calendarYearReturn
              }
              benchmarkName={cprRecommendation.summary.benchmark.Name}
            />
            )}
          {
            cprRecommendation &&
            cprRecommendation.modelConstituentDisclosure &&
            cprRecommendation.modelConstituentDisclosure.length > 0 &&
            <CyPortfolioModelConstituentDisclosure
              modelConstituentDisclosure={
                cprRecommendation.modelConstituentDisclosure
              }
              managerList={cprRecommendation.managers}
              userIsApproved={true}
            />
          }
        </React.Fragment>
    }
    </section>
  </React.Fragment>
}

export default CprTest;



// WEBPACK FOOTER //
// ./src/containers/CprTest/index.jsx